var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.psuTypeLabels),function(psuTypeLabel,psuType){return _c('Chip',{key:`psu-type-${psuType}`,attrs:{"name":"psu-type","title":psuTypeLabel,"value":psuType,"checked":_vm.selectedPsuType === psuType},on:{"change":_vm.setPsuType}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }